const cdServerUrl = "https://cce.scu.edu.cn/mana/web";
//const serverUrl = "http://192.168.0.133:86/selfExamUnit";
 const serverUrl = "http://202.115.44.70/selfExamUnit";
const gjtServerUrl = 'http://gjt.51100.net/exam';
//通知公告
// const sysServerUrl = "http://192.168.0.1:8990";
export default {
    cdServerUrl,
    serverUrl,
    gjtServerUrl
}

